import { LicniNacinOtpreme, StatusEOtpremnice } from './../../../../../data-api/src/lib/eKompanija-api';
import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  AdresaIsporukeDto,
  FazaVoznjeDto,
  IAdresaIsporukeDto,
  IEOtpremnicaDto,
  IFazaVoznjeDto,
  IJedinicaMereDto,
  IKontaktOsobaDto,
  ILicniNacinOtpremeDto,
  IOpasnaMaterijaDto,
  IPredmetStavkeDto,
  IStavkaOtpremniceDto,
  IStrankaOtpremniceDto,
  IVozacFazeDto,
  JedinicaMereDto,
  KontaktOsobaDto,
  LicniNacinOtpremeDto,
  NacinOtpreme,
  OpasnaMaterijaDto,
  StrankaOtpremniceDto,
  TipOtpremnice,
  VozacFazeDto,
  VrstaDokumentaOtpremnica,
} from '@kodit/core/data-api';
import { StrankaRacunaForm } from '@kodit/core/services';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import { OtpremnicaForm } from 'libs/core/moduli/racun/src/lib/otpremnica/otpremnica.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { StavkaEoptremniceFormService } from '../form-definitions/stavka-eotpremnice-form.service';

@Injectable({
  providedIn: 'root',
})
export class EotpremnicaFormService {
  public _isInitialized: boolean;
  private _form!: EOtpremnicaForm;

  constructor(
    private _fb: FormBuilderTypeSafe,
    private _stavkeService: StavkaEoptremniceFormService
  ) {
    this._isInitialized = false;
  }

  getForm(model: IEOtpremnicaDto): EOtpremnicaForm {
    if (!this._isInitialized) {
      this._init(model);
      this._isInitialized = true;
    }
    return this._form;
  }

  private _init(model: IEOtpremnicaDto) {
    this._form = this._fb.group<IEOtpremnicaDto>({
      id: new FormControl(model?.id),
      tipOtpremnice: new FormControl(model?.tipOtpremnice),
      vrstaDokumenta: new FormControl(VrstaDokumentaOtpremnica.IZLAZNA),
      broj: new FormControl(model?.broj),
      datumIzdavanjaOtpremnice: new FormControl(
        model?.datumIzdavanjaOtpremnice ?? new Date()
      ),
      tezinaIsporuke: new FormControl(model?.tezinaIsporuke),
      zapreminaIsporuke: new FormControl(model?.zapreminaIsporuke),
      stvarniDatum: new FormControl(model?.stvarniDatum, {
        validators: [Validators.required],
      }),
      brojPaketa: new FormControl(model?.brojPaketa ?? 0),
      brojUgovora: new FormControl(model?.brojUgovora),
      brojNarudzbenice: new FormControl(model?.brojNarudzbenice),
      brojOkvirnogSporazuma: new FormControl(model?.brojOkvirnogSporazuma),
      jeRobaTreceStrane: new FormControl(model?.jeRobaTreceStrane ?? false),
      napomena: new FormControl(model?.napomena),
      robaTreceStrane: new FormControl(model?.robaTreceStrane),
      strankaDto: this.getStrankaOtpremniceFormGroup(model?.strankaDto),
      posiljalacKontaktDto: this.getKontaktOsobaFormGroup(
        model?.posiljalacKontaktDto
      ),
      primalacKontaktDto: this.getKontaktOsobaFormGroup(
        model?.primalacKontaktDto
      ),
      nacinOtpreme: new FormControl(model?.nacinOtpreme, {
        validators: [Validators.required],
      }),
      licniNacinOtpreme: this.getLicniNacinOtpremeFormGroup(
        model?.licniNacinOtpreme
      ),
      adresaOtpremeDto: this.getAdresaIsporukeFormGroup(
        model?.adresaOtpremeDto
      ),
      adresaOdredistaDto: this.getAdresaIsporukeFormGroup(
        model?.adresaOdredistaDto
      ),
      fazeVoznjeDto: this.getFazeVoznjeFormArray(model?.fazeVoznjeDto),
      stavkeDto: this._stavkeService.GetFormArray(model?.stavkeDto),
      jedinicaMereTezinaDto: this.getJedinicaMereFormGroup(
        model?.jedinicaMereTezinaDto
      ),
      jedinicaMereZapreminaDto: this.getJedinicaMereFormGroup(
        model?.jedinicaMereZapreminaDto
      ),
      planiraniDatumPocetka: new FormControl(model?.planiraniDatumPocetka, {
        validators: [Validators.required],
      }),
      planiraniDatumZavrsetka: new FormControl(model?.planiraniDatumZavrsetka, {
        validators: [Validators.required],
      }),
      napomenaIsporuke: new FormControl(model?.napomenaIsporuke),
      povratRobe: new FormControl(model?.povratRobe ?? false),
      createdBy: new FormControl(model?.createdBy),
      createdOn: new FormControl(model?.createdOn ?? new Date()),
      lastModifiedBy: new FormControl(model?.lastModifiedBy),
      lastModifiedOn: new FormControl(model?.lastModifiedOn),
      opasneMaterijeDto: this.getOpasneMaterijeFormArray(
        model?.opasneMaterijeDto
      ),
      imaOpasneMaterije: new FormControl(model?.imaOpasneMaterije ?? false),
      status: new FormControl(model?.status ?? StatusEOtpremnice.NACRT),
      praviloZaBrojId : new FormControl(model?.praviloZaBrojId, {
        validators: [Validators.required],
      }),
      brojOtpremniceTrecaStrana : new FormControl(model?.brojOtpremniceTrecaStrana)
    });
  }

  /**
   * Postavljanje forme racuna
   */
  otpremnicaForm$ = new BehaviorSubject<EOtpremnicaForm>(null);

  set setOtpremnicaForm(value: EOtpremnicaForm) {
    this.otpremnicaForm$.next(value);
  }

  get getOtpremnicaFormObject(): EOtpremnicaForm {
    return this.otpremnicaForm$.getValue();
  }

  public getStrankaOtpremniceFormGroup(
    model?: IStrankaOtpremniceDto
  ): FormGroupTypeSafe<IStrankaOtpremniceDto> {
    return this._fb.group<IStrankaOtpremniceDto>({
      id: new FormControl(model?.id),
      naziv: new FormControl(model?.naziv, {
        validators: [Validators.required],
      }),
      adresa: new FormControl(model?.adresa),
      pib: new FormControl(model?.pib),
      mb: new FormControl(model?.mb),
      tipStranke: new FormControl(model?.tipStranke),
      jeAktivna: new FormControl(model?.jeAktivna),
      brojUgovora: new FormControl(model?.brojUgovora),
      brojTendera: new FormControl(model?.brojTendera),
      registracioniBroj: new FormControl(model?.registracioniBroj),
      jbkjs: new FormControl(model?.jbkjs),
    });
  }

  public getKontaktOsobaFormGroup(
    model?: IKontaktOsobaDto
  ): FormGroupTypeSafe<IKontaktOsobaDto> {
    return this._fb.group<IKontaktOsobaDto>({
      ime: new FormControl(model?.ime),
      telefon: new FormControl(model?.telefon),
      email: new FormControl(model?.email),
    });
  }

  public getLicniNacinOtpremeFormGroup(
    model?: ILicniNacinOtpremeDto
  ): FormGroupTypeSafe<ILicniNacinOtpremeDto> {
    return this._fb.group<ILicniNacinOtpremeDto>({
      id: new FormControl(model?.id),
      ime: new FormControl(model?.ime),
      prezime: new FormControl(model?.prezime),
      brojLicneKarte: new FormControl(model?.brojLicneKarte),
    });
  }

  public getAdresaIsporukeFormGroup(
    model?: IAdresaIsporukeDto
  ): FormGroupTypeSafe<IAdresaIsporukeDto> {
    return this._fb.group<IAdresaIsporukeDto>({
      id: new FormControl(model?.id),
      ulica: new FormControl(model?.ulica, {
        validators: [Validators.required],
      }),
      broj: new FormControl(model?.broj),
      mesto: new FormControl(model?.mesto, {
        validators: [Validators.required],
      }),
      postanskiBroj: new FormControl(model?.postanskiBroj),
      magacinId: new FormControl(model?.magacinId),
      nazivMagacina: new FormControl(model?.nazivMagacina),
      sifraObjekta: new FormControl(model?.sifraObjekta)
    });
  }

  public getFazaVoznjeFormGroup(
    model?: IFazaVoznjeDto
  ): FormGroupTypeSafe<IFazaVoznjeDto> {
    return this._fb.group<IFazaVoznjeDto>({
      id: new FormControl(model?.id),
      mestoUtovara: new FormControl(model?.mestoUtovara, {
        validators: [Validators.required],
      }),
      mestoIsporuke: new FormControl(model?.mestoIsporuke,{
        validators: [Validators.required],
      }),
      prevoznikDto: this.getStrankaOtpremniceFormGroup(model?.prevoznikDto),
      vozacDto: this.getVozacFazeFormGroup(model?.vozacDto),
      vozacFazeId: new FormControl(model?.vozacFazeId ?? 0),
      redniBroj: new FormControl(model?.redniBroj)
    });
  }

  public getFazeVoznjeFormArray(models?: FazaVoznjeDto[]): FormArray {
    return this._fb.array(
      models?.map((m) => this.getFazaVoznjeFormGroup(m)) ?? []
    );
  }

  public getVozacFazeFormGroup(
    model?: IVozacFazeDto
  ): FormGroupTypeSafe<IVozacFazeDto> {
    return this._fb.group<IVozacFazeDto>({
      id: new FormControl(model?.id),
      ime: new FormControl(model?.ime),
      prezime: new FormControl(model?.prezime),
      email: new FormControl(model?.email),
      telefon: new FormControl(model?.telefon),
      registarskiBrojVozila: new FormControl(model?.registarskiBrojVozila),
      brojVozackeDozvole: new FormControl(model?.brojVozackeDozvole),
    });
  }

  public getJedinicaMereFormGroup(
    model?: IJedinicaMereDto
  ): FormGroupTypeSafe<IJedinicaMereDto> {
    return this._fb.group<IJedinicaMereDto>({
      id: new FormControl(model?.id),
      naziv: new FormControl(model?.naziv),
    });
  }

  public getOpasnaMaterijaFormGroup(
    model?: IOpasnaMaterijaDto
  ): FormGroupTypeSafe<IOpasnaMaterijaDto> {
    return this._fb.group<IOpasnaMaterijaDto>({
      id: new FormControl(model?.id),
      naziv: new FormControl(model?.naziv),
      vrednost: new FormControl(model?.vrednost),
      komentar: new FormControl(model?.komentar),
    });
  }

  public getOpasneMaterijeFormArray(models?: IOpasnaMaterijaDto[]): FormArray {
    return this._fb.array(
      models?.map((m) => this.getOpasnaMaterijaFormGroup(m)) ?? []
    );
  }


  get jeEdit(): boolean {
    if (!this._form) {
      return false;
    }
    return this._form!.value!.id! > 0;
  }

  public jePretovarEditSubject = new BehaviorSubject<boolean>(false);
  readonly jePretovarEdit$ = this.jePretovarEditSubject.asObservable();

  setJePretovarEdit(value: boolean): void {
    this.jePretovarEditSubject.next(value);
  }

  //#region STRANKA
  get getStrankaEOtpremniceFormGroup(): StrankaOtpremniceForm {
    if (!this.getOtpremnicaFormObject) {
      return null;
    }
    return this.getOtpremnicaFormObject.getSafe<IStrankaOtpremniceDto>(
      (x) => x.strankaDto
    ) as StrankaOtpremniceForm;
  }

  set setStrankaOtpremnice(stranka: IStrankaOtpremniceDto) {
    if (!stranka) {
      return;
    }
    this.getStrankaEOtpremniceFormGroup.patchValue(stranka);
    this.getStrankaEOtpremniceFormGroup.updateValueAndValidity();
  }
  //#endregion STRANKA

  public nacinOtpremeSubject = new BehaviorSubject<NacinOtpreme>(null);
  readonly nacinOtpreme$ = this.nacinOtpremeSubject.asObservable();

  setNacinOtpreme(value: NacinOtpreme): void {
    this.nacinOtpremeSubject.next(value);
  }

  private tipOtpremniceSubject = new BehaviorSubject<TipOtpremnice>(null);
  readonly tipOptremnice$ = this.tipOtpremniceSubject.asObservable();

  setTipOtpremnice(value: TipOtpremnice): void {
    this.tipOtpremniceSubject.next(value);
  }

  //#region STAVKE

  get getStavkeArray(): FormArray {
    if (!this.getOtpremnicaFormObject) {
      return new FormArray([]);
    }
    return this.getOtpremnicaFormObject.controls.stavkeDto as FormArray;
  }

  addedPredmetiStavki$ = new BehaviorSubject<number[]>(null);

  get getAddedPredmetiStavki() {
    return this.addedPredmetiStavki$.asObservable();
  }

  set setAddedPredmetiStavki(value: number[]) {
    this.addedPredmetiStavki$.next(value);
  }

  patchPredmetStavke(
    predmetstavke: IPredmetStavkeDto,
    stavkaIndex: number,
    kolicina?: number
  ) {
    this.getStavkaByIndex(stavkaIndex).controls.predmetStavkeDto?.patchValue(
      predmetstavke
    );
    // if (
    //   this.getStavkaByIndex(stavkaIndex).get('predmetStavkeDto').value.oznakeDto
    //     .length === 0
    // ) {
    //   this._patchOznake(stavkaIndex, predmetstavke.oznakeDto);
    // } // da li trebaju oznake??

    this.getStavkaByIndex(stavkaIndex).patchValue({
      gtin: predmetstavke.gtin,
      jedinicaMereDto: predmetstavke.jedinicaMereDto,
      naziv: predmetstavke.naziv,
      sifra: predmetstavke.sifra,
      ...(kolicina != null && { kolicina }),
    });
  }

  getStavkaByIndex(index: number): StavkeOtpremniceForm {
    if (!this.getOtpremnicaFormObject) {
      return null;
    }

    return this.getOtpremnicaFormObject
      .getSafe<IStavkaOtpremniceDto[]>((x) => x.stavkeDto)
      .get([index]) as StavkeOtpremniceForm;
  }

  //#endregion STAVKE

  //#region PREVOZNIK U FAZI

  getStrankaPrevoznikFazaFormGroup(index: number): StrankaOtpremniceForm {
    if (!this.getOtpremnicaFormObject) {
      return null;
    }

    const faza = this.getFazaByIndex(index);
    if (!faza) {
      console.warn('Faza nije pronađena za index:', index);
      return null;
    }
    return faza.get('prevoznikDto') as StrankaOtpremniceForm;
  }

  setStrankaPrevoznikFaze(stranka: IStrankaOtpremniceDto, index: number) {
    if (!stranka) {
      return;
    }
    this.getStrankaPrevoznikFazaFormGroup(index).patchValue(stranka);
    this.getStrankaPrevoznikFazaFormGroup(index).updateValueAndValidity();
  }

  //#endregion PREVOZNIK U FAZI

  //#region FAZE VOZNJE
  getFazaByIndex(index: number): FazaVoznjeForm {
    if (!this.getOtpremnicaFormObject) {
      return null;
    }

    const fazeArray = this.getOtpremnicaFormObject.get(
      'fazeVoznjeDto'
    ) as FormArray;
    if (!fazeArray || !fazeArray.at(index)) {
      return null;
    }

    return fazeArray.at(index) as FazaVoznjeForm;
  }

  get getFazeVoznjeArray(): FormArray {
    if (!this.getOtpremnicaFormObject) {
      return new FormArray([]);
    }
    return this.getOtpremnicaFormObject.controls.fazeVoznjeDto as FormArray;
  }

  //#endregion FAZE VOZNJE

  //#region OPASNE MATERIJE

  get getOpasneMaterijeArray(): FormArray {
    if (!this.getOtpremnicaFormObject) {
      return new FormArray([]);
    }
    return this.getOtpremnicaFormObject.controls.opasneMaterijeDto as FormArray;
  }

  //#endregion OPASNE MATERIJE

  //#region LICNI NACIN OTPERME

  get getLicniNacinOtpremeGroup(): LicniNacinOtpremeForm {
    if (!this.getOtpremnicaFormObject) {
      return null;
    }
    return this.getOtpremnicaFormObject.getSafe<ILicniNacinOtpremeDto>(
      (x) => x.licniNacinOtpreme
    ) as LicniNacinOtpremeForm;
  }

  //#endregion LICNI NACIN OTPREME

  //#region ADRESA OTPREME
  get getAdresaOtpremeFormGroup(): StrankaOtpremniceForm {
    if (!this.getOtpremnicaFormObject) {
      return null;
    }
    return this.getOtpremnicaFormObject.getSafe<IAdresaIsporukeDto>(
      (x) => x.adresaOtpremeDto
    ) as StrankaOtpremniceForm;
  }

  set setAdresaOtpreme(adresa: IAdresaIsporukeDto) {
    if (!adresa) {
      return;
    }
    this.getAdresaOtpremeFormGroup.patchValue(adresa);
    this.getAdresaOtpremeFormGroup.updateValueAndValidity();
  }
  //#endregion ADRESA OTPREME

  //#region ADRESA ODREDISTA
  get getAdresaOdredistaFormGroup(): AdresaOtpremeForm {
    if (!this.getOtpremnicaFormObject) {
      return null;
    }
    return this.getOtpremnicaFormObject.getSafe<IAdresaIsporukeDto>(
      (x) => x.adresaOdredistaDto
    ) as AdresaOtpremeForm;
  }

  set setAdresaOdredista(adresa: IAdresaIsporukeDto) {
    if (!adresa) {
      return;
    }
    this.getAdresaOdredistaFormGroup.patchValue(adresa);
    this.getAdresaOdredistaFormGroup.updateValueAndValidity();
  }
  //#endregion ADRESA ODREDISTA

  resetForm() {
    this.setOtpremnicaForm = null;
    this._isInitialized = false;
    this._init({});
  }
}

export declare type EOtpremnicaForm = FormGroupTypeSafe<IEOtpremnicaDto> | null;
export declare type StrankaOtpremniceForm = FormGroupTypeSafe<IStrankaOtpremniceDto>;
export declare type StavkeOtpremniceForm = FormGroupTypeSafe<IStavkaOtpremniceDto>;
export declare type FazaVoznjeForm = FormGroupTypeSafe<IFazaVoznjeDto>;
export declare type LicniNacinOtpremeForm = FormGroupTypeSafe<ILicniNacinOtpremeDto>;
export declare type AdresaOtpremeForm = FormGroupTypeSafe<IAdresaIsporukeDto>;
export declare type AdresaOdredistaForm = FormGroupTypeSafe<IAdresaIsporukeDto>;


